import React from 'react';

const LocationInfoBox = ({ info }) => {
    return (
        <div className='locationInfoBox'>
            <h2>Event Location Info</h2>
            <ul>
                <li>
                    ID: <strong>{info.id}</strong>
                </li>
                <li>
                    TITLE: <strong>{info.title}</strong>
                </li>
            </ul>
        </div>
    );
};

export default LocationInfoBox;
